import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Box, Divider, Paper, CircularProgress } from '@mui/material';
import Layout from '../components/Layout';
import UserSearch from '../components/UserSearch';
import UserDetails from '../components/UserDetails';
import { getUserWithPhotoDetails } from '../services/users';

const DashboardPage = () => {
  const navigate = useNavigate();
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleUserFound = async (result) => {
    // If we get a single user, navigate to user details page
    if (!Array.isArray(result)) {
      if (result && result.id) {
        navigate(`/dashboard/user/${result.id}`);
      }
      return;
    }
    
    // If we get multiple users, store the array for selection
    if (result.length > 0) {
      setSearchResults(result);
      setSelectedUser(null);
    } else {
      setSearchResults([]);
      setSelectedUser(null);
    }
  };
  
  // When selecting a user from the results list
  const handleSelectUser = (user) => {
    if (user && user.id) {
      navigate(`/dashboard/user/${user.id}`);
    }
  };

  return (
    <Layout>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          User Management
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Search for users by their ID or username, and manage their profiles.
        </Typography>
      </Box>

      <UserSearch onUserFound={handleUserFound} />

      {searchResults.length > 1 && (
        <Paper sx={{ mb: 3, p: 2 }}>
          <Typography variant="h6" gutterBottom>
            Multiple users found ({searchResults.length})
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {searchResults.map((user) => (
              <Box 
                key={user.id}
                onClick={() => handleSelectUser(user)}
                sx={{
                  p: 1, 
                  border: '1px solid',
                  borderColor: selectedUser?.id === user.id ? 'primary.main' : 'divider',
                  borderRadius: 1,
                  cursor: 'pointer',
                  '&:hover': { bgcolor: 'action.hover' }
                }}
              >
                <Typography variant="body2">
                  {user.profile?.name || 'Unnamed'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {user.id}
                </Typography>
              </Box>
            ))}
          </Box>
          <Divider sx={{ my: 2 }} />
        </Paper>
      )}

      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
          <CircularProgress />
        </Box>
      )}

      {/* User details are now displayed on a separate page */}
    </Layout>
  );
};

export default DashboardPage;
